import './App.css'

import { ToasterComponent } from './features/toaster/ui/ToasterComponent'
import WheelLand from './components/wheel-land/WheelLand'
import PixelScripts from './components/PixelScripts'

function App() {
    return (
        <div>
            <PixelScripts />
            <WheelLand />
            <div id="modals" />
            <ToasterComponent />
        </div>
    )
}

export default App
